// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) {
  .modal_contentWrapper__p2dCR {
    width: 80%;
    min-width: 768px;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/most/list/history/item/modal.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 768px) {\n  .contentWrapper {\n    width: 80%;\n    min-width: 768px;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `modal_contentWrapper__p2dCR`
};
export default ___CSS_LOADER_EXPORT___;
